/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConversationsByIdsRequest
 */
export interface ConversationsByIdsRequest {
    /**
     * Array of needed ids
     * @type {Array<string>}
     * @memberof ConversationsByIdsRequest
     */
    ids: Array<string>;
}

/**
 * Check if a given object implements the ConversationsByIdsRequest interface.
 */
export function instanceOfConversationsByIdsRequest(value: object): value is ConversationsByIdsRequest {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    return true;
}

export function ConversationsByIdsRequestFromJSON(json: any): ConversationsByIdsRequest {
    return ConversationsByIdsRequestFromJSONTyped(json, false);
}

export function ConversationsByIdsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationsByIdsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
    };
}

export function ConversationsByIdsRequestToJSON(json: any): ConversationsByIdsRequest {
    return ConversationsByIdsRequestToJSONTyped(json, false);
}

export function ConversationsByIdsRequestToJSONTyped(value?: ConversationsByIdsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
    };
}

